export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      areas: "Service Areas",
      gallery: "Gallery",
      appointment: "Schedule Appointment",
      callNow: "Call Now"
    },
    hero: {
      badge: "24/7 Emergency Service",
      title: "Plumbing, Drain & Repair Experts",
      titleHighlight: "in Hampton Roads, VA",
      description: "Pellon Morel Solutions provides professional plumbing, drain cleaning, and repair services in Virginia Beach, Chesapeake, Norfolk, and throughout Hampton Roads. Reliable service, fast response, and quality workmanship.",
      scheduleButton: "Schedule Appointment",
      estimateButton: "Get Free Estimate",
      phone: "(757) 650-3192",
      phoneText: "(757) 650-3192",
      location: "Virginia Beach • Norfolk • Chesapeake"
    },
    about: {
      subtitle: "About Us",
      title: "New Generation of Plumbers",
      description: "We are a new generation of plumbers, a family dedicated to providing high-quality residential plumbing services. Our commitment is to offer fast, efficient and lasting solutions for all your plumbing problems, backed by years of experience and a team of certified professionals.",
      features: [
        {
          title: "Residential Specialists",
          description: "Focused exclusively on residential plumbing services for homeowners"
        },
        {
          title: "Quality Guarantee",
          description: "All our work is backed by full warranty"
        },
        {
          title: "Certified Staff",
          description: "Licensed and highly trained plumbers"
        },
        {
          title: "24/7 Availability",
          description: "Immediate response for emergencies anytime"
        }
      ]
    },
    services: {
      subtitle: "Our Services",
      title: "Complete Residential Plumbing Solutions",
      description: "We offer a wide range of professional services to meet all your home plumbing needs",
      emergencyTitle: "24/7 Emergency Service",
      emergencyDescription: "We are available at any time to attend to your plumbing emergencies. Guaranteed fast response.",
      emergencyButton: "Call Now for Emergencies",
      list: [
        {
          name: "Comprehensive Plumbing",
          description: "Complete solutions for all your residential plumbing needs."
        },
        {
          name: "New Construction",
          description: "Complete installation of plumbing systems for new home construction projects."
        },
        {
          name: "Repairs",
          description: "Fast and efficient repair of leaks, faucets and plumbing problems."
        },
        {
          name: "Water Heater Installation",
          description: "Installation and replacement of electric and gas water heaters."
        },
        {
          name: "Drain Cleaning",
          description: "Professional drain and pipe cleaning and unclogging service."
        },
        {
          name: "Re-Piping",
          description: "Complete replacement of old or damaged pipes in your home."
        },
        {
          name: "Kitchen Plumbing",
          description: "Installation and repair of sinks, faucets and kitchen systems."
        },
        {
          name: "Bathroom Plumbing",
          description: "Complete installation of bathrooms, showers, toilets and sinks."
        },
        {
          name: "Laundry Room",
          description: "Installation and connection of washers and laundry systems."
        }
      ]
    },
    gallery: {
      subtitle: "Project Gallery",
      title: "Our Work",
      description: "See the quality and professionalism we bring to every project",
      shareText: "Have photos of your project? Share them with us",
      shareButton: "Share Your Project"
    },
    appointment: {
      subtitle: "Schedule Appointment",
      title: "Reserve Your Appointment Today",
      description: "Select the date and time that works best for you. We will confirm your appointment via email or SMS.",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        service: "Service",
        date: "Date",
        time: "Time",
        notes: "Additional Notes",
        notesPlaceholder: "Briefly describe the work you need...",
        selectService: "Select a service",
        selectDate: "Select a date",
        selectTime: "Select a time",
        submit: "Schedule Appointment",
        submitting: "Scheduling..."
      },
      validation: {
        selectDate: "Please select a date",
        selectTime: "Please select a time"
      },
      success: "Appointment scheduled successfully! We will contact you soon.",
      error: "Error scheduling appointment. Please try again."
    },
    estimate: {
      subtitle: "Request Estimate",
      title: "Get a Free Estimate",
      description: "Provide your project details and we will send you a detailed estimate without obligation.",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        service: "Service",
        address: "Address",
        addressPlaceholder: "Street, City, State, Zip Code",
        description: "Job Description",
        descriptionPlaceholder: "Describe in detail the work you need. Include any specific problems, affected area, and any other relevant details...",
        contactMethod: "Preferred Contact Method",
        contactEmail: "Email",
        contactPhone: "Phone",
        contactSms: "SMS",
        selectService: "Select a service",
        submit: "Request Free Estimate",
        submitting: "Sending..."
      },
      success: "Request sent! We will contact you soon with your estimate.",
      error: "Error sending request. Please try again."
    },
    chat: {
      buttonLabel: "Open chat",
      quickQuestion: "Any questions?",
      title: "Ask me a question",
      description: "Write your question and I'll answer you instantly.",
      emptyState: "Ask me anything about our plumbing services!",
      inputPlaceholder: "Type your question...",
      success: "Message sent! We will respond soon.",
      error: "Error sending message. Please try again."
    },
    footer: {
      description: "Pellon Morel Solutions provides professional plumbing, drain cleaning, and repair services in Virginia Beach, Chesapeake, Norfolk, and throughout Hampton Roads. Reliable service, fast response, and quality workmanship.",
      servicesTitle: "Services",
      contactTitle: "Contact",
      hoursTitle: "Hours",
      phone: "Phone",
      email: "Email",
      location: "Location",
      locationText: "Virginia Beach, Chesapeake & Norfolk",
      emergency: "24/7 Emergencies",
      emergencyText: "Always available",
      regularHours: "Regular Hours:",
      weekdays: "Monday - Friday: 8:00 AM - 6:00 PM",
      saturday: "Saturday: 9:00 AM - 4:00 PM",
      sunday: "Sunday: Emergencies only",
      copyright: "All rights reserved.",
      services: [
        "Comprehensive Plumbing",
        "New Construction",
        "Repairs",
        "Water Heater",
        "Drain Cleaning"
      ]
    }
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      areas: "Áreas de Servicio",
      gallery: "Galería",
      appointment: "Agendar Cita",
      callNow: "Llamar Ahora"
    },
    hero: {
      badge: "Servicio de Emergencia 24/7",
      title: "Expertos en Plomería, Drenajes y Reparaciones",
      titleHighlight: "en Hampton Roads, VA",
      description: "Pellon Morel Solutions ofrece servicios profesionales de plomería, limpieza de drenajes y reparaciones en Virginia Beach, Chesapeake, Norfolk y todo Hampton Roads. Servicio confiable, respuesta rápida y trabajo de calidad.",
      scheduleButton: "Agendar Cita",
      estimateButton: "Estimado Gratis",
      phone: "(757) 650-3192",
      phoneText: "(757) 650-3192",
      location: "Virginia Beach • Norfolk • Chesapeake"
    },
    about: {
      subtitle: "Acerca de Nosotros",
      title: "Nueva Generación de Plomeros",
      description: "Somos una nueva generación de plomeros, somos una familia dedicada a proporcionar servicios residenciales de plomería de alta calidad. Nuestro compromiso es ofrecer soluciones rápidas, eficientes y duraderas para todos los problemas de plomería, respaldados por años de experiencia y un equipo de profesionales certificados.",
      features: [
        {
          title: "Especialistas Residenciales",
          description: "Enfocados exclusivamente en servicios de plomería residencial para propietarios"
        },
        {
          title: "Garantía de Calidad",
          description: "Todos nuestros trabajos están respaldados por garantía completa"
        },
        {
          title: "Personal Certificado",
          description: "Plomeros licenciados y altamente capacitados"
        },
        {
          title: "Disponibilidad 24/7",
          description: "Respuesta inmediata para emergencias en cualquier momento"
        }
      ]
    },
    services: {
      subtitle: "Nuestros Servicios",
      title: "Soluciones Completas de Plomería Residencial",
      description: "Ofrecemos una amplia gama de servicios profesionales para satisfacer todas las necesidades de plomería de su hogar",
      emergencyTitle: "Servicio de Emergencia 24/7",
      emergencyDescription: "Estamos disponibles en cualquier momento para atender sus emergencias de plomería. Respuesta rápida garantizada.",
      emergencyButton: "Llamar Ahora para Emergencias",
      list: [
        {
          name: "Plomería Integral",
          description: "Soluciones completas para todas sus necesidades de plomería residencial."
        },
        {
          name: "Nuevas Construcciones",
          description: "Instalación completa de sistemas de plomería para proyectos de construcción nuevos."
        },
        {
          name: "Reparaciones",
          description: "Reparación rápida y eficiente de fugas, grifos y problemas de plomería."
        },
        {
          name: "Instalación Water Heater",
          description: "Instalación y reemplazo de calentadores de agua eléctricos y a gas."
        },
        {
          name: "Destapado de Drenajes",
          description: "Servicio profesional de limpieza y destapado de drenajes y tuberías."
        },
        {
          name: "Re-Piping",
          description: "Reemplazo completo de tuberías antiguas o dañadas en su hogar."
        },
        {
          name: "Plomería de Cocina",
          description: "Instalación y reparación de lavaplatos, grifos y sistemas de cocina."
        },
        {
          name: "Plomería de Baño",
          description: "Instalación completa de baños, duchas, inodoros y lavabos."
        },
        {
          name: "Laundry Room",
          description: "Instalación y conexión de lavadoras y sistemas de lavandería."
        }
      ]
    },
    gallery: {
      subtitle: "Galería de Proyectos",
      title: "Nuestros Trabajos",
      description: "Vea la calidad y profesionalismo que aportamos a cada proyecto",
      shareText: "¿Tiene fotos de su proyecto? Compártalas con nosotros",
      shareButton: "Compartir Su Proyecto"
    },
    appointment: {
      subtitle: "Agendar Cita",
      title: "Reserve Su Cita Hoy",
      description: "Seleccione la fecha y hora que mejor le convenga. Le confirmaremos su cita vía email o SMS.",
      form: {
        name: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        service: "Servicio",
        date: "Fecha",
        time: "Hora",
        notes: "Notas Adicionales",
        notesPlaceholder: "Describa brevemente el trabajo que necesita...",
        selectService: "Seleccione un servicio",
        selectDate: "Seleccione una fecha",
        selectTime: "Seleccione una hora",
        submit: "Agendar Cita",
        submitting: "Agendando..."
      },
      validation: {
        selectDate: "Por favor seleccione una fecha",
        selectTime: "Por favor seleccione una hora"
      },
      success: "¡Cita agendada exitosamente! Le contactaremos pronto.",
      error: "Error al agendar la cita. Por favor intente nuevamente."
    },
    estimate: {
      subtitle: "Solicitar Estimado",
      title: "Obtenga un Estimado Gratuito",
      description: "Proporcione los detalles de su proyecto y le enviaremos un estimado detallado sin compromiso.",
      form: {
        name: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        service: "Servicio",
        address: "Dirección",
        addressPlaceholder: "Calle, Ciudad, Estado, Código Postal",
        description: "Descripción del Trabajo",
        descriptionPlaceholder: "Describa detalladamente el trabajo que necesita. Incluya cualquier problema específico, área afectada, y cualquier otro detalle relevante...",
        contactMethod: "Método de Contacto Preferido",
        contactEmail: "Email",
        contactPhone: "Teléfono",
        contactSms: "SMS",
        selectService: "Seleccione un servicio",
        submit: "Solicitar Estimado Gratis",
        submitting: "Enviando..."
      },
      success: "¡Solicitud enviada! Le contactaremos pronto con su estimado.",
      error: "Error al enviar la solicitud. Por favor intente nuevamente."
    },
    chat: {
      buttonLabel: "Abrir chat",
      quickQuestion: "¿Alguna pregunta?",
      title: "Hazme una pregunta",
      description: "Escribe tu pregunta y te respondo al instante.",
      emptyState: "¡Pregúntame lo que quieras sobre nuestros servicios de plomería!",
      inputPlaceholder: "Escribe tu pregunta...",
      success: "¡Mensaje enviado! Le responderemos pronto.",
      error: "Error al enviar el mensaje. Por favor intente nuevamente."
    },
    footer: {
      description: "Pellon Morel Solutions ofrece servicios profesionales de plomería, limpieza de drenajes y reparaciones en Virginia Beach, Chesapeake, Norfolk y todo Hampton Roads. Servicio confiable, respuesta rápida y trabajo de calidad.",
      servicesTitle: "Servicios",
      contactTitle: "Contacto",
      hoursTitle: "Horario",
      phone: "Teléfono",
      email: "Email",
      location: "Ubicación",
      locationText: "Virginia Beach, Chesapeake y Norfolk",
      emergency: "Emergencias 24/7",
      emergencyText: "Disponible siempre",
      regularHours: "Horario Regular:",
      weekdays: "Lunes - Viernes: 8:00 AM - 6:00 PM",
      saturday: "Sábado: 9:00 AM - 4:00 PM",
      sunday: "Domingo: Solo emergencias",
      copyright: "Todos los derechos reservados.",
      services: [
        "Plomería Integral",
        "Nuevas Construcciones",
        "Reparaciones",
        "Water Heater",
        "Destapado de Drenajes"
      ]
    }
  }
};